import { InjectionToken } from "@angular/core";
import { environment } from "../../environments/environment";

export const API_PATH_VALUE = environment.API_PATH;

export let API_PATH_INJECTABLE = new InjectionToken<string>("API_PATH");
